module.exports = __webpack_public_path__ + "img/x-circle.d10d9d0b.svg";